import { Pipe, PipeTransform } from '@angular/core';
import { Activity } from '../models/activity';

@Pipe({
    name: 'excludeActivity',
    pure: false,
    standalone: false
})
export class ExcludeActivityPipe implements PipeTransform {
    transform(items: Activity[]): any {
        if (!items) {
            return items;
        }
        return items.filter(item => item.Status === 2);
    }
}
